import { take, put } from "redux-saga/effects";
import { GET_ACTIVITY_FEED, getActivityFeedActions } from "src/redux/actions/dashboard";
import { getSchoolActivityFeed } from "src/services/http/dashboard";
import { ActivityFeedResponse } from "src/redux/actions/dashboard/types";

import * as Effects from "redux-saga/effects";
const call: any = Effects.call;

function* watchGetActivityFeedRequest() {
  while (true) {
    const { payload }: IActionType<{ schoolId: number; groupId?: number; limit?: number; offset?: number }> =
      yield take(GET_ACTIVITY_FEED.REQUEST);

    try {
      const result: ActivityFeedResponse = yield call(getSchoolActivityFeed, payload);
      yield put(getActivityFeedActions.success(result));
    } catch (e) {
      yield put(getActivityFeedActions.error(e as any));
    }
  }
}

export default watchGetActivityFeedRequest;
